import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../settings/index';
import Api, { executeAction } from '../../../helpers/api';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import { t } from '../../../i18n';
import notifications from '../../../redux/notifications/actions';

const api = new Api('dashboard/unclosed_jobs');
const usersList = new Api('administrators/list?pageSize=2000');

function* loadData({ payload }) {
  try {
    const {
      page = 1,
      pageSize = tableConfig.pageSize,
      column = 'starts_at',
      order = 'descend',
      filter,
      ...restPayload
    } = payload;
    const search = { ...restPayload, page, pageSize, column, order, filter };
    const { jobs, users } = yield all({
      jobs: call(sendRequest, api.load, { search }, notifications.REQUEST_ERROR),
      users: call(sendRequest, usersList.load, {}, notifications.REQUEST_ERROR),
    });

    if (jobs?.data?.success?.data && users?.data?.data) {
      const { records, totalCount, filteredCount, sortableColumns, filters } = jobs.data.success.data;

      yield put(
        actions.loadDataSuccess({
          users: users.data.data.map(item => ({
            id: item.id,
            name: `${item.first_name || ''} ${item.last_name || ''}`,
          })),
          data: records,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns,
          filters,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* processAction({ payload }) {
  try {
    const { method, url, key, adminId, cb } = payload;

    const data = {};

    if (key === 'assign_action') {
      data.assign = { admin_id: adminId };
    }

    const result = yield call(sendRequest, executeAction, { url, method, data }, notifications.REQUEST_ERROR);

    if (result && result.data) {
      if (cb) {
        cb();
      }
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t(
            `dash.common.notification.${
              key === 'unassign_action' ? 'unassigned_successfully' : 'assigned_successfully'
            }`,
            {
              item: t('dash.landingPage.unclosed_jobs.unclosed_job'),
            },
          ),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData), takeEvery(actions.PROCESS_ACTION, processAction)]);
}
